import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const AppointmentTypeOnsite: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon fillRule="evenodd" stroke="none" {...props}>
      <g clipPath="url(#clip0_13294_452)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8906 4.40625H18.0469V3H16.6406V4.40625H7.35938V3H5.95312V4.40625H5.10938C3.94627 4.40625 3 5.35252 3 6.51562V18.8906C3 20.0537 3.94627 21 5.10938 21H18.8906C20.0537 21 21 20.0537 21 18.8906V6.51562C21 5.35252 20.0537 4.40625 18.8906 4.40625ZM19.5938 18.8906C19.5938 19.2783 19.2783 19.5938 18.8906 19.5938H5.10938C4.72167 19.5938 4.40625 19.2783 4.40625 18.8906V9.60938H19.5938V18.8906ZM4.40625 8.20312H19.5938V6.51562C19.5938 6.12792 19.2783 5.8125 18.8906 5.8125H18.0469V7.21875H16.6406V5.8125H7.35938V7.21875H5.95312V5.8125H5.10938C4.72167 5.8125 4.40625 6.12792 4.40625 6.51562V8.20312Z"
          fill="currentColor"
        />
        <mask id="mask0_13294_452" maskUnits="userSpaceOnUse" x="9" y="10" width="6" height="9">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.375 13.5C9.375 12.0488 10.5488 10.875 12 10.875C13.4513 10.875 14.625 12.0488 14.625 13.5C14.625 15.4688 12 18.375 12 18.375C12 18.375 9.375 15.4688 9.375 13.5ZM11.0625 13.5C11.0625 14.0175 11.4825 14.4375 12 14.4375C12.5175 14.4375 12.9375 14.0175 12.9375 13.5C12.9375 12.9825 12.5175 12.5625 12 12.5625C11.4825 12.5625 11.0625 12.9825 11.0625 13.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_13294_452)">
          <rect x="7.5" y="10.125" width="9" height="9" fill="currentColor" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_13294_452">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
